// extracted by mini-css-extract-plugin
export default {"Separador":"SeparadorChico_Separador__JSXql"};